import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth, type AppRole } from './auth-context';

export function ProtectedRoute({
  children,
  role,
}: {
  children: React.ReactNode;
  role: Exclude<AppRole, 'unknown'>;
}) {
  const { session, role: actualRole, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation('common');

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-muted-foreground">
        {t('states.loading')}
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role mismatch — redirect to the user's actual surface rather than 403.
  if (actualRole !== 'unknown' && actualRole !== role) {
    return <Navigate to={actualRole === 'trainer' ? '/trainer' : '/client'} replace />;
  }

  return <>{children}</>;
}
